function astMethods(type) {
    return (generatorName, checkerName) => ({
        [generatorName]: (props) => ({
            type,
            ...props
        }),
        [checkerName]: (entity) => typeof entity === 'object' && entity !== null && entity.type === type
    });
}
/**
 * AST structure generators and matchers.
 * For instance, `ast.selector({rules: [...]})` creates AstSelector and `ast.isSelector(...)` checks if
 * AstSelector was specified.
 *
 * @example
 *
 * // Represents CSS selector: ns|div#user-34.user.user-active[role=button]:lang(en) > *
 * const selector = ast.selector({
 *     rules: [
 *         ast.rule({
 *             tag: ast.tagName({name: 'div', namespace: ast.namespaceName({name: 'ns'})}),
 *             ids: ['user-34'],
 *             classNames: ['user', 'user-active'],
 *             attributes: [
 *                 ast.attribute({
 *                     name: 'role',
 *                     operator: '=',
 *                     value: ast.string({value: 'button'})
 *                 })
 *             ],
 *             pseudoClasses: [
 *                 ast.pseudoClass({
 *                     name: 'lang',
 *                     argument: ast.string({value: 'eng'})
 *                 })
 *             ],
 *             pseudoElement: 'before',
 *             nestedRule: ast.rule({combinator: '>', tag: ast.wildcardTag()})
 *         })
 *     ]
 * });
 * console.log(ast.isSelector(selector)); // prints true
 * console.log(ast.isRule(selector)); // prints false
 */
export const ast = {
    ...astMethods('Selector')('selector', 'isSelector'),
    ...astMethods('Rule')('rule', 'isRule'),
    ...astMethods('TagName')('tagName', 'isTagName'),
    ...astMethods('WildcardTag')('wildcardTag', 'isWildcardTag'),
    ...astMethods('NamespaceName')('namespaceName', 'isNamespaceName'),
    ...astMethods('WildcardNamespace')('wildcardNamespace', 'isWildcardNamespace'),
    ...astMethods('NoNamespace')('noNamespace', 'isNoNamespace'),
    ...astMethods('Attribute')('attribute', 'isAttribute'),
    ...astMethods('PseudoClass')('pseudoClass', 'isPseudoClass'),
    ...astMethods('String')('string', 'isString'),
    ...astMethods('Formula')('formula', 'isFormula'),
    ...astMethods('FormulaOfSelector')('formulaOfSelector', 'isFormulaOfSelector'),
    ...astMethods('Substitution')('substitution', 'isSubstitution')
};
